import { useEffect } from "react";

const ReviewCertificate = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.trustindex.io/loader.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <script
      defer
      async
      src="https://cdn.trustindex.io/loader-cert.js?284d03c52268117596660e04e7c"
    ></script>
  );
};

export default ReviewCertificate;
